import useSQLite from '../useSQLite'
import { defineSqliteFeature } from './define-feature'

const { getItem, setItem } = useSQLite()

// Subject 7: the phone's copies of the notifications journal and of the admin's
// config (src/lib/notifications/), read without network. Kept out of the http
// cache on purpose: its boot prune drops whatever was not rewritten for 7 days,
// while these copies must hold as long as the account stays signed in (the
// journal copy keeps only its 60 last days by itself). Purged at logout.
export const NOTIFICATIONS_PREFIX = 'notifications:'

export const readNotificationsCopy = (key) => getItem(`${NOTIFICATIONS_PREFIX}${key}`, null)

export const writeNotificationsCopy = (key, data) => setItem(`${NOTIFICATIONS_PREFIX}${key}`, data)

export default defineSqliteFeature({
    key: 'notifications',
    purgeOnLogout: true,
    ensureSchema: () => Promise.resolve(),
    // Nothing expires at boot, see above.
    onBoot: async () => ({ ok: true, cleared: 0 }),
    getSummary: ({ getKeyStats }) => getKeyStats({ prefix: NOTIFICATIONS_PREFIX }),
    purge: ({ pruneKeys }) => pruneKeys({ prefix: NOTIFICATIONS_PREFIX }),
    fallbacks: {
        onBoot: { ok: false, cleared: 0 },
        getSummary: null,
        purge: { ok: false, cleared: 0 },
    },
})
